export default {
  methods: {
    checkForErrors() {
      const result = {
        error: false,
        message: ""
      };

      if (this.dataInicial.length == 0 && this.dataFinal.length == 0) {
        result.error = true;
        result.message =
          "Os campos de data inicial e data final são obrigatórios!";
      } else if (this.dataInicial.length == 0) {
        result.error = true;
        result.message = "O campo de data inicial é obrigatório";
      } else if (this.dataFinal.length == 0) {
        result.error = true;
        result.message = "O campo de data final é obrigatório";
      }

      let inicio = this.dataInicial.split("/").reverse();
      let fim = this.dataFinal.split("/").reverse();

      if (new Date(inicio) > new Date(fim)) {
        result.error = true;
        result.message = "Data Final não pode ser menor que a Data Inicial";
      }

      if (new Date() < new Date(fim)) {
        result.error = true;
        result.message = "Data Final não pode maior que a data de hoje";
      }

      if (new Date() < new Date(inicio)) {
        result.error = true;
        result.message = "Data Inicial não pode maior que a data de hoje";
      }

      return result;
    }
  }
};
